
import NoMatchView from '@/modules/pe-basic-module/views/NoMatchView'
import getAllViews from '@/settings/getAllViews'
import { Route } from 'react-router'
import { DEFAULT_404_PROPS } from 'src/libs/interfaces/dummies'
import { IMenuItem } from 'src/libs/interfaces/layouts'
import { IUser } from 'src/settings/zustand'
import { addRoute } from './addRoute'
import defaultRoutings from './defaultRoutings'
import LoginView from 'src/modules/pe-basic-module/views/LoginView'

export default function initRouting(lyt: any, user: IUser): IMenuItem[] { 
    let routeItems: any[] = []
    let ElComponento: any, ElComponento2: any  
    const views = getAllViews()
    defaultRoutings().forEach((menuGroup: IMenuItem, n: number) => {
        routeItems = addRoute(
            { ...menuGroup, i: n,  },
            n, 
            ElComponento, 
            ElComponento2, 
            user,
            views,
            routeItems
        )
    })
    // console.log( lyt.routing )
    Object.keys(lyt.routing).forEach((menuGroup: string, n: number) => {
        lyt.routing[menuGroup].forEach((m: IMenuItem, i: number) => { 
            routeItems = addRoute(
                { ...m, i: 1000 + 1000 * n + i }, 
                n, 
                ElComponento, 
                ElComponento2, 
                user,
                views,
                routeItems
            )
            //console.log( m.children )
        })
    }) 
    routeItems = [
        ...routeItems,
        <Route path='login' element={<LoginView />} key={"loading"}/>,
        <Route path='*' element={<NoMatchView {...DEFAULT_404_PROPS} />} key={ "404" }  />,
    ]
    return routeItems
}